module.exports = __webpack_public_path__ + "static/media/Nets_Logo_Pos_RGB.4b0963f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/Nets_Logo_Pos_RGB.png
// module id = 659
// module chunks = 0